export const surveyFilterOptionsArray = {FEATURES:'Features', ECONSENTS:'Consent', QUESTIONNAIRES:'Survey', TOOLS:'Tools'};